import { MutationTuple } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { useToast } from '@televet/kibble-ui/build/components/Toast';
import {
  AddChannelMemberMutation,
  AddChannelMemberMutationVariables,
  useAddChannelMemberMutation,
} from 'shared/types/graphql';

const useAddChannelMember = (): MutationTuple<AddChannelMemberMutation, AddChannelMemberMutationVariables> => {
  const toast = useToast();

  return useAddChannelMemberMutation({
    refetchQueries: ['getPetParentChannels', 'getChannelListChannels', 'getClinicChannelViewChannel'],
    onError: (error) => {
      Sentry.captureException(error);
      console.error(error);
      toast({
        status: 'error',
        title: 'An error occurred while adding this member to the conversation.',
      });
    },
  });
};

export default useAddChannelMember;
